export var CreateFileStorageMethod;

(function (CreateFileStorageMethod) {
  CreateFileStorageMethod["DIRECT"] = "DIRECT";
  CreateFileStorageMethod["SIGNED_URL"] = "SIGNED_URL";
})(CreateFileStorageMethod || (CreateFileStorageMethod = {}));